import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {useDebounce} from "../../common/hooks/useDebounce";
import {useAccessToken} from "../../common/hooks/useAccessToken";
import {CollapsibleSearch} from "../../ui/CollapsibleSearch";
import {TenantSearchOptionCard} from "./TenantSearchOptionCard";
import {BuildingSearchOptionCard} from "./BuildingSearchOptionCard";
import {GAEvent} from "../../common/google_analytics/google_analytics";
import {constants} from "../../common/constants/constants";

const MIN_LETTERS_TO_SEARCH = 2;
const SPECIAL_PLACEHOLDER_END_DATE = new Date('2025-03-20'); // Set end date for special message

export const GlobalSearch = () => {
    const {t} = useTranslation();
    const client = useAccessToken();

    const [search, setSearch] = useState(null);
    const [isLoading, setIsLoading] = useState(null);
    const [searchOptions, setSearchOptions] = useState(null);

    const msDelayAfterTyping = 500;
    const deferredFilter = useDebounce(search, msDelayAfterTyping);

    /**
     * @param tenantsResult
     * @returns {*|*[]}
     */
    const getTenantOptions = (tenantsResult) => {
        if (!tenantsResult?.length) return [];
        return tenantsResult?.map(tenant => {
            return <TenantSearchOptionCard tenant={tenant}/>
        }).filter(option => !!option);
    }

    /**
     * @param tenantsResult
     * @returns {*|*[]}
     */
    const getBuildingCollectionReportOptions = (buildings) => {
        if (!buildings?.length) return [];
        return buildings?.map(building => {
            return <BuildingSearchOptionCard building={building} key={building.externalID} />
        }).filter(option => !!option);
    }

    useEffect(async () => {
        // https://bllink.atlassian.net/browse/SSB-1878
        // start search to BE only after 2 letters typed
        if (!search || search.length < MIN_LETTERS_TO_SEARCH) {
            setSearchOptions([]);
            return;
        }
        setIsLoading(true);
        const {tenantsResult, bankInfoResult, offlinePaymentsByConfirmationID} = await client.managers.globalSearch.getGlobalSearchResults(search)
            .finally(() => setIsLoading(false));
        GAEvent(constants.GoogleAnalytics.Events.general, 'searchBarSearched', 1, 'searchBarSearched');
        const searchOptions = [
            ...getBuildingCollectionReportOptions(offlinePaymentsByConfirmationID),
            ...getTenantOptions(bankInfoResult),
            ...getTenantOptions(tenantsResult)];
        setSearchOptions(searchOptions);
    }, [deferredFilter])

    // Function to determine which placeholder to show
    const getPlaceholder = () => {
        const currentDate = new Date();
        if (currentDate <= SPECIAL_PLACEHOLDER_END_DATE) {
            return 'חדש! חיפוש אסמכתא בצ׳קים/העברות שתועדו';
        }
        return ''; // Default placeholder from translations
    };

    return <CollapsibleSearch
        onChange={e => setSearch(e)}
        searchOptions={searchOptions}
        isLoading={isLoading}
        placeholder={getPlaceholder()}
    />
}
